const decodeEvent = (event) => {
  const data = event.split("\n").filter(line => line.startsWith("data:"))
    .map(line => line.slice(5).trimStart()).join("\n");
  if (!data) return null;
  const payload = JSON.parse(data);
  if (payload.error) throw new Error("AI generation failed");
  return payload;
};

export const readLyricStream = async (response, onDelta) => {
  if (!response.ok || !response.body) throw new Error("Lyric stream unavailable");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let lyrics = "";
  let completion = null;
  const consume = (event) => {
    const payload = decodeEvent(event);
    if (payload?.delta) {
      if (typeof payload.delta !== "string") throw new Error("Invalid lyric response");
      lyrics += payload.delta;
      onDelta(lyrics);
    }
    if (payload?.done === true) completion = payload;
  };
  try {
    for (;;) {
      const { done, value } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      // Normalize complete CRLF pairs only, retaining chunk-split carriage returns.
      buffer = buffer.replace(/\r\n/g, "\n");
      const events = buffer.split("\n\n");
      buffer = events.pop();
      events.forEach(consume);
      if (done) break;
    }
    if (buffer.trim()) consume(buffer);
    if (!completion || !lyrics.trim()) throw new Error("Lyric stream ended before completion");
    return { lyrics, model: completion.model };
  } finally {
    reader.releaseLock();
  }
};